import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__download-white",
  "use": "Custom__download-white-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"Custom__download-white\"><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"m9 3.36-3 3-3-3h2.25v-3h1.5v3H9ZM7.887 5.974l.84-.84L12 6.36v3l-6 2.25-6-2.25v-3l3.273-1.227.84.84L1.066 7.11 6 8.95l4.934-1.84-3.047-1.136Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol